import { TermsAndConditionsLink } from '@/components/features/common/TermsAndConditions';
import WrappedModal from '@/components/ui/WrappedModal';
import useTheme from '@/theme/useTheme';
import { Box } from '@mui/system';
import { Trans, useTranslation } from 'next-i18next';
import Link from 'next/link';

const ThursdayTAndC = ({
  showModal,
  setShowModal,
}: {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
}) => {
  const [t] = useTranslation();
  const { theme } = useTheme();
  const termsConditions = [
    {
      text: `To claim Thursday Reload bonus, the deposit must be made on Thursday ( 00:00 UTC - 23:59 UTC ). The qualifying deposit must be made as a single transaction. The bonus is available only on Thursday, once a week.`,
    },
    {
      text: `Bonus is available to the players who have made at least 2 deposits.`,
    },
    {
      text: `The first 50 free spins are added immediately after a successful deposit, the next 50 - in another 24 hours.`,
    },
    {
      text: `Winnings obtained with the help of free spins have a x40 wagering requirement.`,
    },
    {
      text: `All deposit bonuses must be wagered at least 40 times before the player can withdraw the winnings received through them.`,
    },
    {
      text: `<tcLink>Thursday Reloaded Deposit Bonus Terms & Conditions</tcLink> to find out more.`,
      components: {
        tcLink: (
          <Link
            href="/benefits/deposit#reload-bonus"
            style={{
              color: theme.palette.primary.main,
              textDecoration: 'underline',
            }}
          />
        ),
      },
    },
    {
      text: `<tcLink>General Bonus Terms & Conditions</tcLink> must be observed.`,
      components: {
        tcLink: (
          <Link
            href="/help/general-bonuses-terms-conditions"
            style={{
              color: theme.palette.primary.main,
              textDecoration: 'underline',
            }}
          />
        ),
      },
    },
  ];
  return (
    <WrappedModal
      sxs={{
        wrapperSX: {
          width: { xs: '100%', md: '800px' },
        },
      }}
      open={showModal}
      onClose={() => setShowModal(false)}
      titleComp={
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          {t('TERMS & CONDITIONS (18+)')}
        </Box>
      }
    >
      <Box
        component={'ul'}
        padding={1}
        sx={{
          fontSize: '16px',
          lineHeight: '28px',
        }}
      >
        {termsConditions.map((item, index) => {
          return (
            <li key={index} style={{ marginTop: '10px' }}>
              <Trans i18nKey={t(item.text)} components={item.components} />
            </li>
          );
        })}
      </Box>
    </WrappedModal>
  );
};

export default ThursdayTAndC;
